import { render, staticRenderFns } from "./Suburb.vue?vue&type=template&id=4e9f1138&"
import script from "./Suburb.vue?vue&type=script&lang=js&"
export * from "./Suburb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports